import React, { Component } from 'react';
// import { Redirect } from "react-router-dom";
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Input } from 'react-materialize';
import * as actions from '../redux/actions';
import { connect } from 'react-redux';

import Logger from '../functions/logging';
import * as auth from '../functions/auth';

import forgotPassword from '../api/forgotPassword';

import whiteLogo from '../assets/landing/pilotly-logo-white.png';

import PageLoader from '../components/global/PageLoader';

import localeMessages from '../locales/login';

import '../static/pilotly.css';
import '../static/Login.css';

/* Google analytics */
import SessionStatus from '../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../analytics/analytics-events/constants';

class ForgotPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: { email: "" },
			loading: false,
			message: null,
			errors: {}
		};

		this.validate     = this.validate.bind(this);
		this.submit       = this.submit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {
		let key = event.target.name;
		let value = event.target.value;

		let fields = { ...this.state.fields };
		fields[key] = value;

		Logger.log(this.constructor.name, "handleChange()", key, value);

		this.setState({ 
			fields: fields,
			message: null,
			errors: {}
		});
	}

	validate() {
		let fields = { ...this.state.fields };
		let errors = {};

		if (!fields.email) {
			errors['email'] = this.props.intl.formatMessage(localeMessages.login_error_email_missing);
		} else if (!auth.isValidEmail(fields.email)) {
			errors['email'] = this.props.intl.formatMessage(localeMessages.login_error_email_invalid);
		}

		return Object.keys(errors).length ? errors : false;
	}

	hasErrors() {
		return Object.keys(this.state.errors).length ? true : false;
	}

	getError() {
		const errorKeys = Object.keys(this.state.errors);

		if (errorKeys.length) {
			return this.state.errors[errorKeys[0]];
		}
		return "";
	}

	submit(event) {
		event.preventDefault();

		let fields = { ...this.state.fields };

		let errors = this.validate(fields);
		if (errors) {
			this.setState({ errors: errors });
			return;
		}

		this.setState({ loading: true, errors: {} }, () => {
			this.emailPassword(fields);
		});
	}

	async emailPassword(fields) {
		Logger.log(this.constructor.name, "emailPassword()", (fields ? fields.email : null));
		/* Google analytics event */
		let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_FORGOT_PASSWORD, '', '', false, false, true);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.state = 'start';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

		try {
			const result = await forgotPassword(fields.email);

			if (result) {
				Logger.log(this.constructor.name, "emailPassword() Successful", result);
				this.setState(() => ({
					message: this.props.intl.formatMessage(localeMessages.forgot_password_request_submitted),
					loading: false
				}));

				/* Google analytics event */
				let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_FORGOT_PASSWORD, '', '', false, false, true);
				sessionStatus.gaTracker = this.props.tracker;
				sessionStatus.state = 'finish';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

			} else {
				Logger.log(this.constructor.name, "emailPassword() request Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.forgot_password_error_failed);
				this.setState({ 
					errors,
					loading: false
				});

				/* Google analytics event */
				let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_FORGOT_PASSWORD, '', '', false, false, true);
				sessionStatus.gaTracker = this.props.tracker;
				sessionStatus.state = 'fail';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			let reason = error.reason ? error.reason : error.toString();

			reason = this.props.intl.formatMessage(localeMessages.forgot_password_error_failed);

			Logger.log(this.constructor.name, "emailPassword() request Failed error", reason, error);
			errors["reason"] = reason;
			this.setState({ 
				errors,
				loading: false
			});
		}
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		return (
			<div className="pilotly-login">
				<PageLoader addedClass="pilotly-blue-background" loading={this.state.loading} small={true} />
				<div className="pilotly-login-header">
					<a href="/"><img className="pilotly-login-header-logo" src={whiteLogo} alt="pilotly"/></a>
				</div>
				<div className="pilotly-login-container">
					<div className="pilotly-login-content">
						<h1 className="pilotly-login-title">
							<FormattedMessage
								id="password.forgot.title"
								defaultMessage={"Forget your password?"}
							/>
						</h1>
						<h2 className="pilotly-login-subtitle">
							<FormattedMessage
								id="password.forgot.sub-title"
								defaultMessage={"Enter your email to reset your password."}
							/>
						</h2>
						<form className="pilotly-login-form pilotly-login-inner" onSubmit={this.submit}>
							<div className={"pilotly-login-alert pilotly-login-alert-error" + (this.hasErrors() ? "" : " display-none")}>
								<p>
									<strong>
										{this.getError()}
									</strong>
								</p>
							</div>

							<div className={"pilotly-login-alert pilotly-login-alert-message" + (this.state.message ? "" : " display-none")}>
								<p>
									<strong>
										{this.state.message}
									</strong>
								</p>
							</div>

							<div className={"" + (this.state.errors.email ? " errors-border" : "")}>
								<Input name="email"
									type="email"
									label={this.props.intl.formatMessage(localeMessages.email)}
									value={this.state.fields.email}
									onChange={(e) => this.handleChange(e)}>
								</Input>
								{/* <p className="error-text" style={{ display: this.state.errors.email ? "block" : "none" }}>
									{this.state.errors.email ? this.state.errors.email : ""}
								</p> */}
							</div>

							<span className="field-no-status"></span>

							<div className="form-input form-input--button">
								<Button tabIndex="3" className="buttonViewX buttonView--defaultX buttonView--primaryX buttonView--largeX button-submitX"
									onClick={this.submit}>
									<FormattedMessage
										id="password.forgot.button.submit"
										defaultMessage={"Submit Request"}
									/>
								</Button>
							</div>
						</form>
					</div>
					<div className="pilotly-login-footer">
						<div className="pilotly-login-footer-top">
							<span>
								<FormattedMessage
									id="password.forgot.register.prompt"
									defaultMessage={"Don’t have an account?"}
								/>
							</span>
							<a className="buttonView buttonView--default buttonView--background" href="/register">
								<FormattedMessage
									id="password.forgot.button.register"
									defaultMessage={"Sign Up"}
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,	
});

export default connect(mapStateToProps, actions)(injectIntl(ForgotPassword));



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword.js